<template>
  <div class="schedule-calendar-month">
    <date-cell v-for="(item, index) in days"
               :date="item.date"
               :type="item.type"
               :whichWeek="Math.floor(index/7)"
               :selectDay="selectDay"
               :days="days"
               :key="index"
               :statusList="statusList"
               :openState="openState"
               @changeDay="getDay"></date-cell>
  </div>
</template>
<script type="text/ecmascript-6">
  import {monthlyCalendar} from './utils'
  import dateCell from './dateCell'
  import {getYearMonthDay} from 'common/js/getYearMonthDay'
  import {saveLocal, loadLocal} from 'common/js/store.js';

  export default {
    components: {
      dateCell,
    },
    props: {
      year: Number,
      month: Number,
      startWeek: Number,
      selectDay: Date,
      openState:Boolean,
    },
    data() {
      return {
        id: (() => loadLocal('id', false))(),
        schoolNow: (() => loadLocal('schoolNow', false))(),
        viewTransition: 'sc-moveTo',
        draggedIndex: -1,
        direction: 'Left',
        animated: false,
        loading: true,
        statusList: null,
      }
    },
    computed: {
      days() {
        //数组，42个(7*6)元素
        // console.log(monthlyCalendar(this.year, this.month, this.startWeek))
        return monthlyCalendar(this.year, this.month, this.startWeek)
      },
      animationClass() {
        return this.viewTransition + this.direction
      },
      mDate() {
        return new Date(this.year, this.month, 0)
      }
    },
    methods: {
      getDay(e) {
        this.$emit('changeDay', e)
      },
      addAnimation(val, old) {
        if (val !== old) {
          this.animated = true
        }
      },
      highlight(index) {
        this.draggedIndex = index
      },
      QueryClassScheduleStatus(startdate, enddate) {
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'ClassSchedule',
            a: 'QueryClassScheduleStatus',
            id: this.id,
            rid: this.schoolNow.rid,
            isstudent: 0,
            startdate: startdate,
            enddate: enddate,
          }
        }).then((response) => {
          response = response.data;
          if (response.code === 111) {
            this.$router.push({path: '/log', query: {url: this.$getUrl.getUrl()}});
          }
          if (response.code === 200) {
            this.statusList = response.list;
          }
        }).catch((err) => {

        });
      }
    },
    watch: {
      mDate(val, old) {
        if (old) {
          if (val < old) {
            this.direction = 'Right'
          }
          if (val > old) {
            this.direction = 'Left'
          }
        }

        if (val !== old) {
          this.animated = true
        }
      },
      days() {
        let startdate = getYearMonthDay(this.days[0].date);
        let enddate = getYearMonthDay(this.days[41].date);
        this.QueryClassScheduleStatus(startdate, enddate);
      }
    },
    created() {

    },
    mounted() {
      let startdate = getYearMonthDay(this.days[0].date);
      let enddate = getYearMonthDay(this.days[41].date);
      this.QueryClassScheduleStatus(startdate, enddate);
    }
  }
</script>
<style lang="stylus" rel="stylesheet/stylus" scoped>

  .schedule-calendar- {
    &month {
      overflow: hidden;
      background: #fff;
    }
  }

  .sc-moveToLeft {
    animation: scMoveToLeft .3s both;
  }

  .sc-moveToRight {
    animation: scMoveToRight .3s both;
  }

  @keyframes scMoveToLeft {
    from {
      transform: translate3d(50%, 0, 0);
      visibility: visible;
    }

    to {
      transform: translate3d(0, 0, 0);
    }
  }

  @keyframes scMoveToRight {
    from {
      transform: translate3d(-50%, 0, 0);
      visibility: visible;
    }

    to {
      transform: translate3d(0, 0, 0);
    }
  }

</style>



// WEBPACK FOOTER //
// src/page/calendarlist/timetable/calendar/month.vue